<template v-if="datosOrigen != null">

  <td>

    <celda-component :nombre="datosOrigen.nombreCliente" />

    <template v-for="sb in obtenerEspaciosCliente" :key="sb.nombre">
      <celda-row-vacio-component :rows="1"  />
    </template>
  </td>


  <!--  Sucursales  -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <celda-component :nombre="sb.nombreSucursal" />
        <template v-for="sb in obtenerEspacioSucursal(sb)" :key="sb.nombre">
          <celda-row-vacio-component :rows="1" />
        </template>
      </tr>
    </template>
  </td>

  <!--  Turnos  -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <tr>
            <celda-component :nombre="turno.nombreTurno" />
            <template v-for="sb in obtenerEspacioTurno(turno)" :key="sb.nombre">
              <celda-row-vacio-component :rows="1" />
            </template>
          </tr>
        </template>
      </tr>
    </template>
  </td>

  <!--  Asistentes  -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <tr>
            <celda-component :nombre="turno.deben_asistir.numeroAsistentes" />
            <template v-for="sb in obtenerEspacioTurno(turno)" :key="sb.nombre">
              <celda-row-vacio-component :rows="1" />
            </template>
          </tr>
        </template>
      </tr>
    </template>
  </td>

  <!--  Asistentes reales -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <tr>
            <celda-component :nombre="turno.deben_asistir.asistencias.numeroAsistentesReales" />
            <template v-for="sb in obtenerEspacioTurno(turno)" :key="sb.nombre">
              <celda-row-vacio-component :rows="1" />
            </template>
          </tr>
        </template>
      </tr>
    </template>
  </td>

  <!--  Evidencias turno -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <tr>
            <celda-component :nombre="turno.deben_asistir.asistencias.evidenciasTurno.numEvidenciasTurno" />
            <template v-for="sb in obtenerEspacioTurno(turno)" :key="sb.nombre">
              <celda-row-vacio-component :rows=1 :forzar="true" />
            </template>
          </tr>
        </template>
      </tr>
    </template>
  </td>

  <!--  Evidencias tomadas -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <tr>
            <celda-component :nombre="turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.numEvidenciasTomadas" />
            <template v-for="sb in obtenerEspacioTurno(turno)" :key="sb.nombre">
              <celda-row-vacio-component :rows="1" />
            </template>
          </tr>
        </template>
      </tr>
    </template>
  </td>

  <!--  NUMERO Empleado -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <template v-for="emp in turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.empleados" :key="emp">
            <tr>
              <celda-component :nombre="emp.numEmpleado" :rows="emp.registros.length" />
            </tr>
            <celda-row-vacio-component :rows="emp.registros.length-1" />
          </template>
        </template>
      </tr>
    </template>
  </td>

  <!--  NOMBRE Empleado -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <template v-for="emp in turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.empleados" :key="emp">
            <tr>
              <celda-component :nombre="emp.nombre" class="celda celda-nombre" />
            </tr>
           <celda-row-vacio-component :rows="emp.registros.length-1" class="celda celda-nombre"/>
          </template>
        </template>
      </tr>
    </template>
  </td>

  <!--  TIPO_REGISTRO Empleado -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <template v-for="emp in turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.empleados" :key="emp">
            <tr>
              <template v-if="emp.registros.length > 0">
                <template v-for="reg in emp.registros" :key="reg[5]">
                  <tr>
                    <td  class="celda" v-if="reg[11]!=null">
                      <a href="#" :id="reg[10]"  @click="verDetalle(reg[10], reg)">{{reg[5]}}</a>
                    </td>
                    <template v-else >
                      <celda-component :nombre="reg[5]" />
                    </template>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <celda-component />
                </tr>
              </template>
            </tr>
          </template>
        </template>
      </tr>
    </template>
  </td>

  <!--  fecha -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <template v-for="emp in turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.empleados" :key="emp">
            <tr>
              <template v-if="emp.registros.length > 0">
                <template v-for="reg in emp.registros" :key="reg[6]">
                  <tr>
                    <celda-component :nombre="reg[6]" />
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <celda-component />
                </tr>
              </template>
            </tr>
          </template>
        </template>
      </tr>
    </template>
  </td>

  <!--  hora -->
  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <template v-for="emp in turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.empleados" :key="emp">
            <tr>
              <template v-if="emp.registros.length > 0">
                <template v-for="reg in emp.registros" :key="reg[7]">
                  <tr>
                    <celda-component :nombre="reg[7]" />
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <celda-component />
                </tr>
              </template>
            </tr>
          </template>
        </template>
      </tr>
    </template>
  </td>

  <!--  horas trabajadas -->

  <td>
    <template v-for="sb in datosOrigen.sucursales" :key="sb.nombre">
      <tr class="tabla-dash">
        <template v-for="turno in sb.turnos" :key="turno.nombreTurno">
          <template v-for="emp in turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.empleados" :key="emp.horasTrabajadas">
            <tr>
              <celda-component :nombre="emp.horasTrabajadas" />
            </tr>
            <celda-row-vacio-component :rows="emp.registros.length-1" />
          </template>
        </template>
      </tr>
    </template>
  </td>

</template>

<script>

import CeldaComponent from "@/components/dashboard/Celda-Component.vue";
import CeldaRowVacioComponent from "@/components/dashboard/Celda-Row-Vacio-Component.vue";

export default {
  name: 'Fila-Component',
  emits: ["verDetalle"],
  components: {CeldaRowVacioComponent, CeldaComponent},
  props: {
    parametro: String,
    datosOrigen: Object
  },
  data() {
    return {
      rowCliente: null
    }
  },
  created() {
  },
  async mounted() {

    if (this.datosOrigen != null && this.datosOrigen.plantilla != null) {
      this.sucursal = [];
      this.datosOrigen.plantilla.forEach(d => {

        const nombreSucursal = d[1];
        const datoEx = this.sucursal.find(c => c === nombreSucursal)
        if (datoEx == null) {
          this.sucursal.push(nombreSucursal);
        }
      });
    }

  },
  methods: {
    verDetalle(token, datos) {
      this.$emit('verDetalle', {token: token, datos: datos});
    },
    obtenerEspaciosCliente() {
      let i=0;
      this.datosOrigen.sucursales.forEach((sb)=> {
        i += this.obtenerEspacioSucursal(sb);
      });

      return i;
    },

    obtenerEspacioSucursal(sb) {
      let i=0;
      sb.turnos.forEach((turno)=> {
        i += this.obtenerEspacioTurno(turno);
      });

      return i;
    },

    obtenerEspacioTurno(turno) {
      let i=0;
      turno.deben_asistir.asistencias.evidenciasTurno.evidencias_tomadas.empleados.forEach((emp)=> {
        i+=1;

        if (emp.registros.length != null && emp.registros.length > 1) {
          i += emp.registros.length-1
        }

      });

      return i;
    }

  },
  filters: {}
};
</script>

<style scoped>

  .celda {
    height: 26px;
  }

  .celda-nombre {
    display: block;
    text-size-adjust: none;
    width: 350px;
    overflow: hidden;
  }
</style>
